<template>
    <div class="select-transfer-date-container">
        <div class="schedule-header mb-3">
            <span class="mb-3 text-sm">
                Selecione uma data para agendar o seu pix. Para torná-lo recorrente, ative a opção "Agendar Recorrência?" abaixo.
            </span>
        </div>
        <div class="mb-3">
            <Calendar id="startDateCalendar"
                label="Data da primeira transferência"
                @on-data-select="setStartDate"
                :value="transferDate.startDate"
                :availableDates="minDate"/>
        </div>
        <div class="mb-3">
            <div class="d-flex align-items-center justify-content-between">
                <span class="form-label mb-0">Transformar em recorrência?</span>
                <div class="toggle-switch">
                    <WhiteLabel>
                        <AppToggle
                            :label="isRecurrence.label"
                            :value="isRecurrence.value"
                            @valueToggle="setIsRecurrence($event)"
                        />
                    </WhiteLabel>
                </div>
            </div>
        </div>

        <div v-if="isRecurrence.value" class="mb-3">
            <h6 class="mb-3">Com que frequência quer transferir?</h6>
            <div class="row mb-2">
                <div class="col-6">
                    <div class="form-check">
                        <input
                            class="form-check-input"
                            type="radio"
                            name="frequency"
                            id="weekly"
                            value="weekly"
                            v-model="transferDate.recurrence.frequency"
                        />
                        <label class="form-check-label" for="weekly">
                            Toda semana
                        </label>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-check">
                        <input
                            class="form-check-input"
                            type="radio"
                            name="frequency"
                            id="quarterly"
                            value="quarterly"
                            v-model="transferDate.recurrence.frequency"
                        />
                        <label class="form-check-label" for="quarterly">
                            A cada trimestre
                        </label>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-check">
                        <input
                            class="form-check-input"
                            type="radio"
                            name="frequency"
                            id="biweekly"
                            value="biweekly"
                            v-model="transferDate.recurrence.frequency"
                        />
                        <label class="form-check-label" for="biweekly">
                            A cada 15 dias
                        </label>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-check">
                        <input
                            class="form-check-input"
                            type="radio"
                            name="frequency"
                            id="sixmonthly"
                            value="sixmonthly"
                            v-model="transferDate.recurrence.frequency"
                        />
                        <label class="form-check-label" for="sixmonthly">
                            A cada semestre
                        </label>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-check">
                        <input
                            class="form-check-input"
                            type="radio"
                            name="frequency"
                            id="monthly"
                            value="monthly"
                            v-model="transferDate.recurrence.frequency"
                        />
                        <label class="form-check-label" for="monthly">
                            Todo mês
                        </label>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-check">
                        <input
                            class="form-check-input"
                            type="radio"
                            name="frequency"
                            id="yearly"
                            value="yearly"
                            v-model="transferDate.recurrence.frequency"
                        />
                        <label class="form-check-label" for="yearly">
                            Todo ano
                        </label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <Calendar
                        id="endDateCalendar"
                        label="Quando deve ser a última transferência?"
                        @on-data-select="setEndDate"
                        :value="transferDate.recurrence.endDate"
                        :availableDates="recurrenceValidDates"/>
                </div>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-6">
                <WhiteLabel>
                    <button type="button" @click="returnStep()" class="btn btn-md col-12">
                        Voltar
                    </button>
                </WhiteLabel>
            </div>
            <div class="col-6">
                <WhiteLabel>
                    <button type="button"
                        :disabled="!validTransferDate"
                        class="btn btn-md col-12"
                        :class="validTransferDate ? 'btn-orange' : 'btn-gray-disabled'"
                        @click="setTransferDate()">
                        Continuar
                    </button>
                </WhiteLabel>
            </div>
        </div>
    </div>
</template>

<script>
import WhiteLabel from '@/components/shared/WhiteLabel';
import AppToggle from '@/components/shared/Toggle';
import Calendar from '@/components/shared/Calendar';
import 'v-calendar/lib/v-calendar.min.css';

export default {
    name: 'SelectTransferDateModalSection',
    components:{
        WhiteLabel,
        AppToggle,
        Calendar,
    },
    data(){
        const nowDate = new Date();
        nowDate.setHours(0, 0, 0, 0);
        return {
            transferDate:{
                startDate: nowDate,
                recurrence: {
                    isRecurrence: false,
                    frequency: 'weekly',
                    endDate: null,
                },
            },
            isRecurrence: { value: false, label: 'Não' },
            showCalendarDateStart: false,
        };
    },
    computed: {
        datePickerColor: function () {
            return window.localStorage.getItem('tertiaryColor') || '#FF7606';
        },
        validTransferDate() {
            let validRecurrence = true;

            if(this.isRecurrence.value == true && !this.transferDate.recurrence.endDate)
                validRecurrence = false;

            return this.transferDate.startDate && validRecurrence;
        },
    },
    watch: {
        'transferDate.recurrence.frequency': function(){
            this.setEndDate(this.calculateNextTransferDate());
        },
        'transferDate.startDate': function(){
            this.setEndDate(this.calculateNextTransferDate());
        },
    },
    methods: {
        minDate(date) {
            const currentDate = date instanceof Date ? date : date.date;

            const today = new Date();
            currentDate.setHours(0, 0, 0, 0);
            today.setHours(0, 0, 0, 0);
            return currentDate >= today;
        },
        setIsRecurrence(value) {
            this.isRecurrence.value = value;
            this.isRecurrence.label = value ? 'Sim' : 'Não';
            this.transferDate.recurrence.isRecurrence = value;
        },
        setStartDate(date) {
            this.transferDate.startDate = date;
        },
        setEndDate(date) {
            this.transferDate.recurrence.endDate = date;
        },
        goBack() {
            this.$emit('go-back');
        },
        setTransferDate(){
            this.$emit('transfer-date', this.transferDate);
        },
        returnStep() {
            this.$emit('return-step');
        },
        changeCalendarDateStart() {
            this.showCalendarDateStart = !this.showCalendarDateStart;
        },
        recurrenceValidDates(date){
            const currentDate = date instanceof Date ? date : date.date;

            const start = new Date(this.transferDate.startDate);
            const frequency = this.transferDate.recurrence.frequency;

            currentDate.setHours(0, 0, 0, 0);
            start.setHours(0, 0, 0, 0);
            if(currentDate <= start)
                return false;

            switch(frequency){
                case 'weekly':
                    return this.diffInDays(start, currentDate) % 7 === 0;
                case 'biweekly':
                    return this.diffInDays(start, currentDate) % 15 === 0;
                case 'monthly':
                    return this.diffInMonths(start, currentDate, 1);
                case 'quarterly':
                    return this.diffInMonths(start, currentDate, 3);
                case 'sixmonthly':
                    return this.diffInMonths(start, currentDate, 6);
                case 'yearly':
                    return this.diffInMonths(start, currentDate, 12);
                default:
                    return true;
            }
        },
        diffInDays(date1, date2){
            const diffTime = date2 - date1;
            return Math.floor(diffTime / (1000 * 60 * 60 * 24));
        },
        diffInMonths(startDate, targetDate, months) {
            startDate.setHours(0, 0, 0, 0);
            targetDate.setHours(0, 0, 0, 0);

            if (targetDate <= startDate) return false;

            let n = 1;
            let currentDate = new Date(startDate);
            const startDay = startDate.getDate();

            while(currentDate.getTime() < targetDate.getTime()){
                const tempDate = new Date(startDate);

                tempDate.setDate(1);
                tempDate.setMonth(startDate.getMonth() + n * months);

                const nextDate = new Date(tempDate);
                const daysInPreviousMonth = new Date(nextDate.getFullYear(), nextDate.getMonth() + 1, 0).getDate();

                if(startDay > daysInPreviousMonth){
                    nextDate.setMonth(nextDate.getMonth() + 1);
                    nextDate.setDate(1);
                }else
                    nextDate.setDate(startDay);

                currentDate = nextDate;

                if(currentDate.getTime() === targetDate.getTime())
                    return true;

                n++;
            }
            return false;
        },
        calculateNextTransferDate(){
            if (!this.transferDate.startDate || !this.transferDate.recurrence.frequency) {
                return null;
            }

            const startDate = new Date(this.transferDate.startDate);
            const frequency = this.transferDate.recurrence.frequency;
            const nextDate = new Date(startDate);

            switch(frequency) {
                case 'weekly':
                    nextDate.setDate(nextDate.getDate() + 7);
                    return nextDate;
                case 'biweekly':
                    nextDate.setDate(nextDate.getDate() + 15);
                    return nextDate;
                case 'monthly':
                    return this.calculateNextMonthlyDate(startDate, 1);
                case 'quarterly':
                    return this.calculateNextMonthlyDate(startDate, 3);
                case 'sixmonthly':
                    return this.calculateNextMonthlyDate(startDate, 6);
                case 'yearly':
                    return this.calculateNextMonthlyDate(startDate, 12);
                default:
                    return null;
            }
        },
        calculateNextMonthlyDate(startDate, monthsToAdd) {
            const nextDate = new Date(startDate);
            const originalDay = startDate.getDate();

            nextDate.setMonth(nextDate.getMonth() + monthsToAdd);

            if (nextDate.getDate() !== originalDay)
                nextDate.setDate(1);

            return nextDate;
        },
    },
};
</script>

<style scoped lang="scss">
p {
    font-size: 1rem !important;
}
.select-transfer-date-container {
    padding: 0px 1.2rem;
}
.schedule-header p{
    font-size: 0.9rem;
    line-height: 1.5;
}
</style>
